import { render } from "./OrderType.vue?vue&type=template&id=1f8b9fcf&scoped=true"
import script from "./OrderType.vue?vue&type=script&lang=js"
export * from "./OrderType.vue?vue&type=script&lang=js"

import "./OrderType.vue?vue&type=style&index=0&id=1f8b9fcf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8b9fcf"]])

export default __exports__